import { ErrorComponentProps, Navigate, createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { reportEvent } from './utils/tracking';
import { RouterContext } from './routes/__root';
import { NotFoundPage } from './components/pages/ErrorPage/NotFoundPage';
import { Alert } from '@razz-team/ui-web';

function RouterError(props: ErrorComponentProps) {
  if (import.meta.env.DEV) {
    return (
      <Alert severity="error">
        {props.error.message}
        <pre>{props.error.stack}</pre>
      </Alert>
    );
  }

  return <Navigate to="/account" />;
}

export const router = createRouter({
  routeTree,
  // we always pass the context inside of <App />
  context: {} as unknown as RouterContext,
  defaultErrorComponent: RouterError,
  defaultNotFoundComponent: NotFoundPage,
});

router.subscribe('onResolved', () => {
  const matches = router.state.matches;
  const route = matches[matches.length - 1];
  if (route) {
    reportEvent({ name: 'page_view', props: { routeId: route.routeId } });
  }
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
